import { render } from "./ResetPasswordBody.vue?vue&type=template&id=e049c7aa"
import script from "./ResetPasswordBody.vue?vue&type=script&lang=js"
export * from "./ResetPasswordBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__